export class ChareEventDateFormatConstant {
    public static readonly GoogleDateFormat = 'YYYYMMDDTHHmmss';
    public static readonly OutlookDateFormat = 'YYYY-MM-DDTHH:mm:ss';
}